/** Push-report rendering for the E911 screen (ADR 0041), unit-testable. */

import type { E911PushReport } from "@pbxmgr/api";

/** One line per push action, for the report list. */
export function summarizePush(report: E911PushReport): string[] {
  const lines = report.entries.map(
    (e) => `location ${e.name} on ${e.node}/${e.domain}: ${e.action}`,
  );
  lines.push(
    ...report.assignments.map(
      (a) =>
        `extension ${a.extension} on ${a.node}/${a.domain} → ${a.location}: ${a.action}`,
    ),
  );
  lines.push(
    ...(report.webhooks ?? []).map(
      (w) => `emergency webhook on ${w.node}/${w.domain}: ${w.action}`,
    ),
  );
  lines.push(...report.notes.map((n) => `note: ${n}`));
  return lines;
}
